import { Fragment } from "react";

// ** Utils & Helpers
import pseudoFormat from "utils/pseudoFormat";

// ** Styled Components
import { StyledTableRow, StyledTableCell } from "../styles";

// #####################################################

const TableRows = ({
	data,
	headers,
	answerHeaders,
	identityKey,
	noModerate,
}) => {
	if (!data || !data.length) {
		return null;
	}
	return data.map((rowData, index) => {
		const key =
			typeof identityKey === "function"
				? identityKey(rowData)
				: `${rowData[identityKey]} `;

		const rowKey = `row - ${key} `;
		const rowCells = headers
			.filter((header) => !header.showInMain)
			.map((column) => ({
				key: `${rowKey} -cell - ${column.key} `,
				hidden: column.hidden,
				isMain: column.isMain,
				showInMain: column.showInMain,
				component: column.rowComponent,
				content: rowData[column.dataKey],
				column,
				data: rowData,
				nowrap: column.nowrap,
				props: column.rowCellProps,
				min: column.min,
				maxWidth: column.maxWidth,
			}));

		const path = rowData?.answer_comments?.comments
			? rowData.answer_comments.comments
			: rowData.answer_comments;

		return (
			<Fragment key={`fragment-${index}`}>
				<StyledTableRow
					key={rowKey}
					moderate={
						!noModerate &&
						(rowData.accepted === false ||
							rowData?.media?.accepted === false ||
							rowData?.media_type === "video_convert" ||
							rowData?.ready === false)
					}
					data-tableRowId={rowKey}
				>
					{rowCells.map((row) => {
						if (row.component) {
							return (
								<StyledTableCell {...row.props} key={row.key}>
									{row.component({
										key: row.key,
										data: {
											...row.data,
											rowKey,
										},
										column: row.column,
										content: row.content,
									})}
								</StyledTableCell>
							);
						}
						return (
							<StyledTableCell {...row.props} key={row.key}>
								{pseudoFormat(row.content, { override: false })}
							</StyledTableCell>
						);
					})}
				</StyledTableRow>

				{rowData.answer_comments &&
					answerHeaders &&
					path.map((rowDataAnswer) => {
						const answerKey =
							typeof identityKey === "function"
								? identityKey(rowDataAnswer)
								: `${rowDataAnswer[identityKey]} `;

						const rowAnswerKey = `row - ${answerKey} `;
						const rowAnswerCells = answerHeaders.map((column) => ({
							key: `${rowAnswerKey} -cell - ${column.key} `,
							hidden: column.hidden,
							isMain: column.isMain,
							showInMain: column.showInMain,
							component: column.rowComponent,
							content: rowDataAnswer[column.dataKey],
							column,
							data: { ...rowDataAnswer, rowData },
							nowrap: column.nowrap,
							props: column.rowCellProps,
							min: column.min,
						}));
						return (
							<StyledTableRow
								key={rowAnswerKey}
								moderate={rowData.accepted === false}
								data-tableRowId={rowAnswerKey}
							>
								{rowAnswerCells.map((row) => {
									if (row.component) {
										return (
											<StyledTableCell
												{...row.props}
												key={row.key}
											>
												{row.component({
													key: row.key,
													data: {
														...row.data,
														rowAnswerKey,
													},
													column: row.column,
													content: row.content,
												})}
											</StyledTableCell>
										);
									}
									return (
										<StyledTableCell
											{...row.props}
											key={row.key}
										>
											{pseudoFormat(row.content, {
												override: false,
											})}
										</StyledTableCell>
									);
								})}
							</StyledTableRow>
						);
					})}
			</Fragment>
		);
	});
};

// #####################################################

export default TableRows;

// #####################################################
